export default __webpack_public_path__ + "static/media/video-img2.b383a59b.jpg";